import axios  from "axios";
import moment from "moment";
import {isMobile,browserName} from 'react-device-detect';

//const getPdfFromApi = (requestData)=>{
const getPdfFromApi = async (requestData)=>{
    let ramadancalendardata = {
        "backgroundurl" : "https://www.islamicity.org/print-prayer-times/images/style1/main_bg.jpg", //set here absolate image path into jpg format
        "logourl" : "", //leave the value empty unless the logo is changed
        "mosqueurl" : "", //leave the value empty unless the logo is changed
        "userheaderdata" : "June 2022<br> Culver City CA", // set the Month year <br> City, State
        "prayermethod" : "Header info<br>Masjed Omae Ibn Khattab", // set the prayer method value
        "calendarDays"  :[{
            "RMDN" : "1",
            "DAY" : "Sat",
            "DATE" : "2 Apr",
            "FJR" : "5:28",
            "DHR" : "12:59",
            "ASR" : "4:31",
            "MGB" : "6:38",
            "ISH" : "8:55",
        },
            {
                "RMDN" : "2",
                "DAY" : "Sat",
                "DATE" : "2 Apr",
                "FJR" : "5:28",
                "DHR" : "12:59",
                "ASR" : "4:31",
                "MGB" : "6:38",
                "ISH" : "8:55",
            }]
    };

    
    return await new Promise((resolve,reject)=>{
        const apiUrl = window.settings.apiUrl;
        const headers = {
            'Authorization': 'ramadancalendar',
        };

        //console.log(browserName.toLowerCase());
        /*
        if ((isMobile && browserName.toLowerCase().includes("safari")) || browserName.toLowerCase().includes("edge") || (isMobile && browserName.toLowerCase().includes("chrome")))  {
            //cookie version enable only for mobile safari, mobile chrome and edge browser
            try{
                const d = new Date();
                d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
                let expires = "expires="+d.toUTCString();
                document.cookie = `icprayertimesdata=${JSON.stringify(requestData)}; ${expires};path=/; domain=islamicity.org`;
                console.log(document.cookie);
               
            }catch(error) {
                console.log(error);
            }

            let response = {
                linkId: 0,
                autoClick: false
            };

            return resolve(response);
       }
     
        axios.post(apiUrl,requestData,headers)
            .then(resp=>{
                const pdfFile = new Blob([resp.data?.pdfcontent],{type: 'application/pdf'});
                let aid = new Date().getTime();
                // const fileURL = URL.createObjectURL(pdfFile);
                let autoClick = true;

                const link = document.createElement('a');
                link.href =  'data:application/pdf;base64,' + resp.data?.pdfcontent;
                link.setAttribute('download','PrayerTimes.pdf');

                link.setAttribute('id', aid);

                document.body.appendChild(link);

                let response = {
                    linkId: aid,
                    autoClick: autoClick
                };

                return resolve(response);
            }).catch(reject)
              */

            //session based solution
            axios.post("savepdf.php",requestData,headers)
            .then(data=>{
                let displaykey = "0";
                if(data.data.iserror == "0")
                {
                    displaykey = data.data.msg;
                }
                let response = {
                    linkId: 0,
                    displaykey: displaykey,
                    autoClick: false
                };

                return resolve(response);
            }).catch(reject)

    })
}

export {getPdfFromApi}
